import { SchedulesLabor } from '../interface/schedules-labor';

export const headers = {
  scheduleLabor: 'Schedules and Labor:',
  reportInfo: 'Report and Info:',
  search: 'Search:',
};
export const mockViewRawData: SchedulesLabor[] = [
  {
    id: 1,
    schedules: 'Maint Schedule Jobs',
    reports: 'RFM Web Reports',
    search: 'WR-WO-TK Search',
    scheduleComponentPath: 'maint-schedule-jobs',
    reportComponentPath: '',
    searchComponentPath: '',
    scheduleDisabled: false,
    reportsDisabled: true,
    searchDisabled: true,
  },
  {
    id: 2,
    schedules: 'Mechanic Hrs Review',
    reports: 'Reports Menu',
    search: '-',
    scheduleComponentPath: '',
    reportComponentPath: 'reports-menu',
    searchComponentPath: '',
    scheduleDisabled: true,
    reportsDisabled: true,
    searchDisabled: true,
  },
  {
    id: 3,
    schedules: 'Cur User Scheduled Jobs',
    reports: 'Service Order Review',
    search: '-',
    scheduleComponentPath: '',
    reportComponentPath: '',
    searchComponentPath: '',
    scheduleDisabled: true,
    reportsDisabled: true,
    searchDisabled: true,
  },
  {
    id: 4,
    schedules: '-',
    reports: 'Worklist Report',
    search: 'Material Request Search',
    scheduleComponentPath: '',
    reportComponentPath: '',
    searchComponentPath: '',
    scheduleDisabled: true,
    reportsDisabled: true,
    searchDisabled: true,
  },
  {
    id: 5,
    schedules: '-',
    reports: '-',
    search: 'Open TASK Pivot Table',
    scheduleComponentPath: '',
    reportComponentPath: '',
    searchComponentPath: '',
    scheduleDisabled: true,
    reportsDisabled: true,
    searchDisabled: true,
  },
  {
    id: 6,
    schedules: '-',
    reports: '-',
    search: '-',
    scheduleComponentPath: '',
    reportComponentPath: '',
    searchComponentPath: '',
    scheduleDisabled: true,
    reportsDisabled: true,
    searchDisabled: true,
  },
  {
    id: 7,
    schedules: '-',
    reports: '-',
    search: '-',
    scheduleComponentPath: '',
    reportComponentPath: '',
    searchComponentPath: '',
    scheduleDisabled: true,
    reportsDisabled: true,
    searchDisabled: true,
  },
  {
    id: 8,
    schedules: '-',
    reports: '-',
    search: 'Cost Code / Edit',
    scheduleComponentPath: '',
    reportComponentPath: '',
    searchComponentPath: '',
    scheduleDisabled: true,
    reportsDisabled: true,
    searchDisabled: true,
  },
];
